import React from 'react';
import PropTypes from 'prop-types';

import { getPageOnHostByID } from 'lib/api';
import { requireQueryByName } from 'lib/dependencies';
import trackAction from 'utils/tracking';

import Breadcrumbs from 'components/Core/Breadcrumbs';
import RichText from 'components/Core/RichText';
import ServiceCard from 'components/ServiceCard';
import CtaBlock from 'components/CtaBlock';

const ServiceIndex = (props) => {
  const {
    page: { title, breadcrumbs, body },
  } = props;

  const onServiceClick = (serviceCategory, serviceName) => {
    trackAction('service-overview', serviceName, serviceCategory);
  };

  return (
    <div className="container mx-auto px-4 u-block-margins">
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <div className="mb-4 md:mb-8">
        <h1 className="text-secondary mb-6">{title}</h1>
      </div>

      {(body || []).map((block) => {
        if (block.blockType === 'CTABlock') {
          return <CtaBlock {...block} key={`block-cta-${block.id}`} />;
        }
        if (block.blockType === 'RichTextBlock') {
          return (
            <div key={`${block.blockType}-${block.id}`} className="flex flex-wrap">
              <div className="flex-full max-w-full lg:flex-2/3 lg:max-w-2/3">
                <RichText blockMargin={false} content={block.value} />
              </div>
            </div>
          );
        }
        if (block.blockType === 'ServiceCategoryBlock' && block.serviceCategories) {
          return (
            <div key={`${block.blockType}-${block.id}`} className="flex flex-wrap -mx-4 u-block-margins">
              {block.serviceCategories.map((serviceCat) => {
                const hasServiceLinks = serviceCat.services && serviceCat.services.length > 0;
                return (
                  hasServiceLinks && (
                    <div
                      key={serviceCat.id}
                      className="flex-full max-w-full sm:flex-1/2 sm:max-w-1/2 xl:flex-1/3 xl:max-w-1/3 px-3 my-4"
                    >
                      <ServiceCard {...serviceCat} onServiceClickCB={onServiceClick} />
                    </div>
                  )
                );
              })}
            </div>
          );
        }
        return <div key={`${block.blockType}-${block.id}`} />;
      })}
    </div>
  );
};

// The data returned here will be send as `props` to the component
// TODO: Let's see if we need this here or can ultimately adopt this into the lib/api calls directly
// That will depend on how different these calls are going to be along the way.
ServiceIndex.getCustomInitialProps = async ({ id, contentType, hostname, previewData }) => {
  const query = requireQueryByName('ServiceIndex');
  const token = previewData ? previewData.token : '';
  const { page } = await getPageOnHostByID({
    id,
    contentType,
    query,
    token,
    hostname,
  });

  return {
    page,
  };
};

ServiceIndex.propTypes = {
  page: PropTypes.shape({
    title: PropTypes.string.isRequired,
    breadcrumbs: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        url: PropTypes.string,
      }),
    ).isRequired,
    body: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};

export default ServiceIndex;
